export const PUBLIC_LAYOUT = 'IndexLayout'
